import { z } from 'zod';
import { TypeOfAPIError } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const responseSchema = z.object({
	isSuccess: z.boolean(),
	encryptedJourneyId: z.string(),
	quotePlanDetail: z.object({
		planId: z.number(),
		networkGroupId: z.number(),
		quoteResponseId: z.number(),
		premiumAmount: z.number(),
		vatAmount: z.number(),
		quotePlanReferenceNumber: z.string(),
	}),
});

const requestSchema = z.object({
	encryptedJourneyId: z.string(),
	quoteReference: z.string(),
	quotePlanReferenceNumber: z.string(),
});

const saveSelectedQuote = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Quote/saveQuotePlanSelection',
		method: 'POST',
		responseSchema,
		requestSchema,
	});

export default saveSelectedQuote;

export type SaveSelectedQuoteError = TypeOfAPIError<ReturnType<typeof saveSelectedQuote>>;
